import { render, staticRenderFns } from "./TermsAndUse.vue?vue&type=template&id=9ab7aa00&scoped=true"
import script from "./TermsAndUse.vue?vue&type=script&lang=js"
export * from "./TermsAndUse.vue?vue&type=script&lang=js"
import style0 from "./TermsAndUse.vue?vue&type=style&index=0&id=9ab7aa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab7aa00",
  null
  
)

export default component.exports